import { Component, Input } from '@angular/core';
import { CodaltComponent } from 'src/app/codalt.component';
import { UserCustomerHistory, UserService } from 'src/app/services/user/user.service';

@Component({
    selector: 'app-user-customer-history',
    standalone: false,
    templateUrl: './user-customer-history.component.html',
    styleUrl: './user-customer-history.component.scss',
})
export class UserCustomerHistoryComponent extends CodaltComponent {
    loading = true;
    customerHistory: UserCustomerHistory[];

    constructor(private userService: UserService) {
        super();
    }

    @Input() set userId(userId: number) {
        this.subscriptions.add(
            this.userService.getUserCustomerHistory(userId).subscribe(
                result => {
                    this.customerHistory = result;
                    this.loading = false;
                },
                () => {
                    this.loading = false;
                }
            )
        );
    }
}
